/**
 * Created by Bart Decorte
 * Date: 2019-04-18
 * Time: 11:04
 */
import Page from '../../pages/Page';

export default class FindReplaceIndex extends Page {}



// WEBPACK FOOTER //
// ./resources/assets/js/website-tools/find-replace/FindReplaceIndex.js